import React from 'react';
import { MoviesContent, MoviesContentProps, STAFF_SELECTION } from './MoviesContent';

export const StaffSelection = (props: MoviesContentProps) => {
  return (
    <MoviesContent
      {...props}
      pageType={STAFF_SELECTION}
      pageTypeParams={{
        staffSelectionOnly: true,
        tabId: 1,
      }}
      basePageUrl="/erotic-films/staff"
    />
  );
};
